import {ErrorTracker, IErrorMessage} from "../../error.tracker";
import inline_errorHtml from './inline-error.html?raw';

export let template: string = inline_errorHtml;

export class viewModel {
    item: IErrorMessage;

    private errorTracker: ErrorTracker;
    private id: any;

    constructor(params: { errorTracker: ErrorTracker, id: any }) {
        this.errorTracker = params.errorTracker;
        this.id = params.id;
        this.item = this.errorTracker.get(this.id) ?? this.errorTracker.add(this.id);
    }

}